import styled from 'styled-components';
import { Sidebar } from '@/components/ui/sidebar';

export const StyledAdminSidebar = styled(Sidebar)`
    --color-sidebar: var(--design-admin-sidebar);
    --color-sidebar-accent: var(--design-admin-sidebar-accent);
    --color-sidebar-border: var(--design-admin-sidebar-border);
`;

export const StyledAdminSidebarContent = styled.div`
    [data-active='true'] {
        background-color: var(--design-admin-sidebar-active) !important;
        color: var(--design-admin-sidebar-active-foreground) !important;
    }

    [data-active='true']:hover {
        background-color: var(--design-admin-sidebar-active) !important;
        color: var(--design-admin-sidebar-active-foreground) !important;
    }
`;
